module.exports = __webpack_public_path__ + "img/img_logo.2bd670f8.webp";